module.exports = {
    // 标题/标题文字
    login: '登录',
    allProductCategories: '全部商品分类',
    productRecommendation: '商品推荐',
    shopRecommendation: '店铺推荐',
    moreProducts: '更多商品',
    moreShops: '更多店铺',
    mainCategory: '主营类目：',
    mainCarType: '主营车型：',
    mainBrand: '主营品牌：',
    location: '所在地区：',
    contact: '联系',
    search: '搜索',
    filterConditions: '筛选条件',
    category: '分类',
    brand: '品牌',
    region: '地区',
    enterSearchContent: '请输入查询内容',
    enterPhoneNumber: '请输入手机号',
    enterVerificationCode: '请输入验证码',
    getVerificationCode: '获取验证码',
    phoneLogin: '手机号登录',
    accountLogin: '账号登陆',
    forgotPassword: '忘记密码？',
    registerNow: '立即注册',
    loginButton: '登 录',
    enterAccount: '请输入账号',
    enterPassword: '请输入密码',
    registerAccount: '注册账号',
    register: '注册',
    confirmPassword: '确认密码',
    enterPhoneNumberAgain: '请输入您的手机号',
    loginSuccess: '登录成功,即将跳转',
    registerSuccess: '注册成功',
    confirmPasswordMatch: '请确认密码',
    welcomeUse: '欢迎使用',
    shopName: '行者智能汽配商城',
    loginDescription: '登录行者智能，与汽配同行一起开启配件流通新时代！',
    enterPasswordPlaceholder: '请输入密码',
    enterVerificationCodePlaceholder: '请输入验证码',
    goOfficialWebsite: '去行者官网',
    fillInVerificationCode: '请填写验证码',
    viewContactInfo: '请登录后获取',
    contactMethod: '联系方式',
    confirm: '确定',
    shopMainBusiness: '公司主营：',
    allProducts: '全部商品',
    companyInfo: '公司信息',
    basicInfo: '基本信息',
    name: '名称',
    partNumber: '图号',
    unit: '单位',
    placeOfOriginBrand: '产地品牌',
    specifications: '规格参数',
    price: '价格',
    addToCart: '加入购物车',
    contactMerchant: '联系商家',
    detailedInfo: '详细信息',
    galleryReview: '照片一览',
    companyIntroduction: '公司简介',
    contactInformation: '联系方式',
    enterpriseName: '企业名称',
    contactPerson: '联系人',
    email: '邮箱',
    address: '地址',
    detailedAddress: '详细地址',
    pleaseLoginToView: '请登录后查看',
    productNamePlaceholder: '商品名称/图号/简码',
    searchThisShop: '搜本店',
    searchAllShops: '搜全站',
    followed: '已关注',
    followShop: '关注店铺',
    collectionSuccessful: '收藏成功',
    cancelCollection: '取消收藏',
    collectionCancelled: '取消成功',
    deleteConfirmation: '将此商品移出购物车？',
    hint: '提示',
    cancel: '取消',
    deleteSuccess: '删除成功',
    deleteCancelled: '已取消删除',
    productDescription: '商品描述',
    allProductCategory: '全部商品分类',
    businessPhilosophy: '经营理念',
    engine: '发动机',
    transmission: '变速箱',
    photoGallery: '照片一览',
    contactWay: '联系方式',
    basicInformation: '基本信息',
    specificationParameters: '规格参数',
    detailedInformation: '详细信息',
    area: '地区',

    // 标签/标签文字
    mainVehicleType: '主营车型',
    shopArea: '所在地区',
    shopLocation: '店铺所在区域',
    filterCondition: '筛选条件',
    area_label: '地区',
    productName: '商品名称',
    drawingNumber: '图号',
    originBrand: '产地品牌',

    // 按钮文字
    mobilePhoneLogin: '手机号登录',
    collectShop: '收藏店铺',
    collected: '已收藏',
    searchAllSites: '搜全站',
    delete: '删除',
    viewBrowsingHistory: '浏览记录',
    productCollection: '商品收藏',
    followedShops: '关注店铺',
    settledStores: '入驻',
    feedback: '意见反馈',
    officialService: '官方客服',
    openShop: '开通商城',
    manageMyShop: '管理我的店铺',
    registerAccount_btn: '注册账号',
    haveAccount: '已有账号登录',

    // 提示语/占位符
    inputPhoneNumber: '请输入手机号',
    inputVerificationCode: '请输入验证码',
    inputAccount: '请输入账号',
    inputPassword: '请输入密码',
    inputVerificationCodeAgain: '请输入验证码',
    pleaseConfirmPassword: '请确认密码',
    inputRequiredItems: '请输入必填项',
    pleaseLogin: '请登录后获取',
    notLoggedIn: '您未登录账号',
    loggedIn: '已登录',
    notOpenedMall: '暂未开通商城',
    haveOpenedMall: '您已开通商城',
    shopProductName: '商品名称/图号/简码',
    searchQueryContent: '请输入查询内容',
    loginToGetPhone: '请登录后获取',
    pleaseFillVerificationCode: '请填写验证码',
    loggingIn: '登陆中',
    loginSuccessRedirecting: '登录成功,即将跳转',
    registerSuccessful: '注册成功',
    collectSuccessful: '收藏成功',
    cancelSuccessful: '取消成功',
    addSuccessful: '添加成功',
    deleteSuccessful: '删除成功',
    removeFromCart: '将此商品移出购物车？',
    cancelDelete: '已取消删除',
    businessConcept: '赋能工厂、三方共赢<br />携手并肩、共筑未来',
    companyDescription: '公司主营项目: 重汽、潍 柴发动机总成及零部件，工程机械发动机及零部件代理各大国际品牌: 德国汉格斯特、 德国马勒、德国曼胡默尔，美国唐纳森国内合作品牌: 中原内配、博立张紧轮、江滨活塞、渤海活塞、威孚增压器',
    transmissionDescription: '适用车型:重卡系列 矿卡系列全系列变速箱总成<br/>专业生产重汽发动机变速箱<br/>变速箱原厂配套全新组装',
    pleaseLoginAfterGetContact: '请登录后查看',
    quote: '—— 本田',
    shopMallName: '行者智能汽配商城',
    shopMallIntro: '登录行者智能，与汽配同行一起开启配件流通新时代！',
    businessPhilosophyText: '赋能工厂、三方共赢<br />携手并肩、共筑未来',
    account: '账号',
    password: '密码',
    phone: '手机号',
    verificationCode: '验证码',
    home: '首页',
    officialWebsite: '系统官网',
    manageSystemExperience: '管理系统体验',
    loginPrompt: '请登录',
    clickToLogout: '点击退出',
    myOrders: '我的订单',
    websiteService: '网站服务',
    contactCustomerService: '联系客服',
    shoppingCartLabel: '购物车',
    confirmLogoutMessage: '是否要退出登录（部分功能将不可用）',
    logoutSuccess: '退出登录!',
    logoutCancelled: '已取消',
    productSearch: '商品查询',
    shopSearch: '店铺查询',
    footerCopyright: 'Copyright © 2024 XingZheZhiNeng All Rights Reserved. 行者智能 版权所有 鲁ICP备2024086448号',
    addWeChatConsultation: '添加微信咨询',
    saveImage: '保存图片',
    productsZone: '产品专区',
    shopsZone: '店铺专区',
    newArrivals: '新品上架',
    clearanceDeals: '滞销捡漏',
    hotProducts: '热卖商品',
    drawingNameSearch: '图号/名称查询',
    languageChanged: '语言已切换'
}